<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col class="pt-0 " cols="12" md="12">
              <h2>{{ getInJournalName }} {{ formData.mandate_code ? '(ID: ' + formData.mandate_code + ')' : '' }}</h2>
              <v-divider class="mt-3"></v-divider>
            </v-col>
            <!-- request-details -->
            <v-col
              v-if="showComponents('RequestDetails')"
              class="pt-0"
              cols="12"
              md="12"
            >
              <expand-form
                :showCards="showCards"
                name="RequestDetails"
                title="Prašymo duomenys"
              />
              <request-details
                v-show="showCards['RequestDetails']"
                :formData="formData"
                :onlyView="editStatus"
              />
              <v-divider class="mt-3"></v-divider>
            </v-col>
            <!-- RequestDataProvider -->
            <v-col
              v-if="showComponents('RequestDataProvider')"
              class="pt-0"
              cols="12"
              md="12"
            >
              <expand-form
                :showCards="showCards"
                name="RequestDataProvider"
                title="Duomenų teikėjas"
              />
              <request-data-provider
                v-show="showCards['RequestDataProvider']"
                :formData="formData"
                :onlyView="editStatus"
              />
              <v-divider class="mt-5"></v-divider>
            </v-col>

            <!-- ProcurationDetailsForm -->
            <v-col
              v-if="showComponents('ProcurationDetailsForm')"
              class="pt-0"
              cols="12"
              md="12"
            >
              <expand-form
                :showCards="showCards"
                name="ProcurationDetailsForm"
                title="Prokūros duomenys"
              />
              <procuration-details-form
                v-show="showCards['ProcurationDetailsForm']"
                :formData="formData"
                :showFull="showOnly"
                :onlyView="editStatus"
              />
              <v-divider class="mt-5"></v-divider>
            </v-col>
            <!-- Deregistration Data  -->
            <v-col
              v-if="showComponents('DeregistrationData')"
              class="pt-0"
              cols="12"
              md="12"
            >
              <expand-form
                :showCards="showCards"
                name="DeregistrationData"
                title="Išregistravimo duomenys"
              />
              <deregistration-data
                v-show="showCards['DeregistrationData']"
                :formData="formData"
                :onlyView="editStatus"
              />
              <v-divider class="mt-3"></v-divider>
            </v-col>

            <!-- Issued Persons Form -->
            <v-col
              v-if="showComponents('IssuedPersonsForm')"
              class="pt-0"
              cols="12"
              md="12"
            >
              <expand-form
                :showCards="showCards"
                name="IssuedPersonsForm"
                title="Juridinis asmuo, išdavęs prokūrą"
              />
              <issued-persons-form
                :showOnly="showOnly"
                v-show="showCards['IssuedPersonsForm']"
                :formData="formData"
                :onlyView="editStatus"
                :canEditContacts="!editStatus"
              />
              <v-divider class="mt-3"></v-divider>
            </v-col>
            <!-- Procurators Form -->
            <v-col
              v-if="showComponents('Procurators')"
              class="pt-0"
              cols="12"
              md="12"
            >
              <expand-form
                :showCards="showCards"
                name="Procurators"
                title="Prokuristai"
              />
              <procurators-form
                :showOnly="showOnly"
                v-show="showCards['Procurators']"
                :formData="formData"
                :onlyView="editStatus"
                :canEditContacts="!editStatus"
              />
              <v-divider class="mt-3"></v-divider>
            </v-col>

            <!-- Cancel Procuracy Person form -->
            <v-col
              v-if="showComponents('CancelPersonsForm')"
              class="pt-0"
              cols="12"
              md="12"
            >
              <expand-form
                :showCards="showCards"
                name="CancelPersonsForm"
                title="Juridinis asmuo, atšaukęs prokūrą"
              />
              <issued-persons-form
                :showOnly="showOnlyCancelPersons"
                v-show="showCards['CancelPersonsForm']"
                :signatures="formData.in_journal_persons"
                :onlyView="editStatus"
                :canEditContacts="!editStatus"
                :customOtherInfo="formData.in_journal_persons[0].fullname || ''"
              />
              <v-divider class="mt-3"></v-divider>
            </v-col>

            <!-- Documents Form -->
            <v-col
              v-if="showComponents('Documents')"
              class="pt-0"
              cols="12"
              md="12"
            >
              <expand-form
                :showCards="showCards"
                name="Documents"
                title="Dokumentai"
              />
              <documents-form
                v-show="showCards['Documents']"
                :formData="formData"
                :onlyView="editStatus"
              />
              <v-divider class="mt-3"></v-divider>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button v-if="editStatus"
            color="secondary"
            @click.native="goBack()"
            title="Atgal"
              />
            <el-button v-if="!editStatus"
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="beforeBack()"
              :loading="loading"
            />
            <el-button v-if="!editStatus"
              class="mr-1"
              title="Saugoti"
              icon="išsaugoti"
              :loading="loading"
              @click.native="beforeSave(false)"
              color="secondary"
            />
            <el-button v-if="!editStatus"
              :title="getButtonTitle"
              icon="išsaugoti"
              :loading="loading"
              @click.native="beforeSave(true)"
              color="primary"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
    <!-- modals -->
     <modal-custom
      title="Prašymo pateikimas"
      text="Ar tikrai norite pateikti šį prašymą? Po pateikimo nebus galima koreguoti šio prašymo duomenų."
      trueText="PATEIKTI"
      falseText="ATŠAUKTI"
      :loading="loading"
      v-model="showModal"
      @confirmData="confirmSave"
    />
    <modal-custom
      title="Pildymo atšaukimas"
      text="Duomenys nebus išsaugoti. Ar tikrai norite atšaukti duomenų pildymą?"
      trueText="Taip"
      falseText="Ne"
      :loading="loading"
      v-model="showCancelModal"
      @confirmData="confirmCancel"
    />
  </v-container>
</template>

<script>
import moment from 'moment'
import userRole from '@/mixins/userRole'
import beforeRequest from '@/mixins/beforeRequest'
import RequestDetails from './RequestDetails.vue'
import RequestDataProvider from './RequestDataProvider.vue'
import DocumentsForm from '../../preparedSentMessages/components/DocumentsForm.vue'
import IssuedPersonsForm from './IssuedPersonsForm.vue'
import ProcuratorsForm from '../../preparedSentMessages/components/ProcuratorsForm.vue'
import DeregistrationData from './DeregistrationData.vue'
import ExpandForm from '../../preparedSentMessages/components/ExpandForm.vue'
import ProcurationDetailsForm from './ProcurationDetailsForm.vue'
import ModalCustom from '@/components/modals/ModalCustom'
import { getFileSetting } from '@/services/classifierService.js'

export default {
  name: 'MainMessageForm',
  components: {
    RequestDetails,
    RequestDataProvider,
    DocumentsForm,
    ProcuratorsForm,
    IssuedPersonsForm,
    DeregistrationData,
    ExpandForm,
    ProcurationDetailsForm,
    ModalCustom
  },
  props: {
    mandateData: [Array, Object],
    createForm: Boolean,
  },
  mixins: [userRole, beforeRequest],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      showModal: false,
      showCancelModal: false,
      loading: false,
      showCards: {},
      formData: {
        status: '801',
        request_date: moment().format('YYYY-MM-DD'),
        procurators: [],
        pro_principals: [],
        documents: [],
      },
    }
  },
  computed: {
    getButtonTitle(){
      if(this.formData.status == '801'){
        return this.formData?.in_journal_type  != '421' ? 'Tęsti' : 'Apmokėta'
      }
      return 'Pateikti'
    },
    showOnly(){
      return this.formData.in_journal_type != '421'
    },
    showOnlyCancelPersons () {
      return this.formData.in_journal_type != '422'
    },
    getId() {
      return this.formData.id || null
    },
    getInJournalName(){
      return this.formData?.in_journal_type ? (
        this.inJournalTypes.filter((type) => type.value == this.formData.in_journal_type)[0].label
      ) : ''
    },
    modeReadonly() {
      return false
    },
    editStatus(){
      return !(this.formData.status == "801" || this.formData.status == "807")
    },
    getTitle() {
      return  this.editStatus ? this.$t(`Prašymas`) : this.$t(`Naujas prašymas`)
    },
    inJournalTypes() {
      return [
        {
          label: this.$t(
            'Prokūrą išdavusio JA prašymas dėl prokūros įregistravimo'
          ),
          value: '421',
        },
        {
          label: this.$t(
            'Prokūrą išdavusio JA prašymas Įgaliojimų registrui dėl prokūros pabaigos'
          ),
          value: '422',
        },
        {
          label: this.$t(
            'Prokuristo prašymas Įgaliojimų registrui dėl prokūros pabaigos'
          ),
          value: '423',
        },
      ]
    },
  },
  mounted() {
    this.fileTypes = sessionStorage.getItem('file_types')
    this.maxSize = sessionStorage.getItem('max_file_size')
    if (!this.fileTypes){
      getFileSetting();
    }
  },
  created() {
    if(this.createForm){
      if(this.mandateData.in_journal_type == '421'){
         this.formData.in_journal_type = this.mandateData.in_journal_type
         this.formData.id = this.mandateData.id
      } else {
        this.formData = this.mandateData
      }
    } else {
      this.formData.id = this.$route.params.id;
      this.getData()
    }
  },
  methods: {
    confirmCancel(){
      this.back()
    },
    beforeBack(){
      this.showCancelModal = true
    },
    showComponents(name) {
      if (this.formData.status == '801') {
        return [
          'RequestDetails',
          'RequestDataProvider',
          'Documents',
        ].includes(name)
      }

      switch (this.formData.in_journal_type) {
        case '421':
          return [
            'RequestDetails',
            'RequestDataProvider',
            'ProcurationDetailsForm',
            'IssuedPersonsForm',
            'Procurators',
            'Documents',
          ].includes(name)
        case '422':
          return [
            'RequestDetails',
            'RequestDataProvider',
            'ProcurationDetailsForm',
            'DeregistrationData',
            'IssuedPersonsForm',
            'Procurators',
            'CancelPersonsForm',
            'Documents',
          ].includes(name)
        case '423':
          return [
            'RequestDetails',
            'RequestDataProvider',
            'ProcurationDetailsForm',
            'DeregistrationData',
            'IssuedPersonsForm',
            'Procurators',
            'Documents',
          ].includes(name)
        default:
          return false
      }
    },
    back() {
      this.$router.push({ name: 'adminRequestsPreparedSent' })
    },
    expandAll() {
      Object.keys(this.showCards).map((key) => {
        this.$set(this.showCards, key, true)
      })
    },
    beforeSave(validate) {
        this.$validator.validateAll().then((res) => {
          if (res) {
            if (!this.formData.data_provider_amn_id) {
              return this.$root.$emit('DATA_ERROR_CODE', '000089')
            }
            if (this.formData.in_journal_type == '421' && this.formData.status != '801' && this.formData.pro_principals.length === 0) {
              return this.$root.$emit('DATA_ERROR_CODE', '000093')
            }
            if (this.formData.in_journal_type == '421' && this.formData.status != '801' && this.formData.procurators.length === 0) {
              return this.$root.$emit('DATA_ERROR_CODE', '000092')
            }
            if (this.formData.in_journal_type == '421' && this.formData.status != '801' &&  this.formData.procuracy_type == "general" && this.formData.procurators.length < 2) {
              return this.$root.$emit('DATA_ERROR_CODE', '000087')
            }
            if (this.formData.in_journal_type == '421' && this.formData.status != '801' && this.formData.procuracy_type == "sole" && this.formData.procurators.length > 1) {
              return this.$root.$emit('DATA_ERROR_CODE', '000091')
            }
            if (this.formData.in_journal_type == '422' && this.formData.status != '801' && this.formData.in_journal_persons.length < 2) {
              return this.$root.$emit('DATA_ERROR_CODE', '000090')
            }
            this.$set(this.formData, 'action', validate ? (this.formData.status == '801' ? 'payed' : 'send') : 'save')
            if(validate && this.formData.status != '801'){
              this.showModal = true
            } else {
              this.saveData()
            }
          } else {
            this.expandAll()
            this.$root.$emit('FORMAT_ERROR')
          }
        })
    },
    getData() {
      this.pageloading = true
      this.$axios
        .get(`in-journals/${this.getId}/request`)
        .then((res) => {
          this.$set(this.formData, 'request_number', res.data.inJournal.request_number || "")
          this.$set(this.formData, 'request_date', res.data.inJournal.request_date || "")
          this.$set(this.formData, 'payed_date', res.data.inJournal.payed_date || "")
          this.$set(this.formData, 'documents', res.data.inJournal.documents || "")
          this.$set(this.formData, 'status', res.data.inJournal.status || "")
          this.$set(this.formData, 'in_journal_type', res.data.inJournal.in_journal_type || "")
          this.$set(this.formData, 'data_provider_other_info', res.data.inJournal.data_provider_other_info || "")
          this.$set(this.formData, 'data_provider_amn_id', res.data.inJournal.data_provider.amn_id || "")
          this.$set(this.formData, 'data_provider', res.data.inJournal.data_provider || {})
          this.$set(this.formData, 'expiration_reason_id', res.data.inJournal.expiration_reason_id || "")
          this.$set(this.formData, 'expiration_reason_description', res.data.inJournal.expiration_reason_description || "")
          this.$set(this.formData, 'basis_date', res.data.inJournal.basis_date || "")
          this.$set(this.formData, 'registration_date', res.data.inJournal.mandate.registration_date || "")
          this.$set(this.formData, 'mandate_id', res.data.inJournal.mandate.id || "")
          this.$set(this.formData, 'mandate_code', res.data.inJournal.mandate.mandate_code || "")
          this.$set(this.formData, 'formation_date', res.data.inJournal.mandate.formation_date || "")
          this.$set(this.formData, 'procuracy_type', res.data.inJournal.mandate.procuracy_type || "")
          this.$set(this.formData, 'procuracy_restricted', res.data.inJournal.mandate.procuracy_restricted == "1")
          this.$set(this.formData, 'procuracy_restriction', res.data.inJournal.mandate.procuracy_restriction || "")
          this.$set(this.formData, 'term', res.data.inJournal.mandate.term || "")
          this.$set(this.formData, 'term_date', res.data.inJournal.mandate.term_date || "")
          this.$set(this.formData, 'pro_principals', res.data.inJournal.mandate.pro_principals || {})
          this.$set(this.formData, 'procurators', res.data.inJournal.mandate.procurators || {})
          this.$set(this.formData, 'mandate_person_id', res.data.inJournal.mandate_person_id || "" )
          if (res.data.inJournal.in_journal_type == "422") {
            // this.$set(this.formData, 'signatures', res.data.inJournal.signatures || {})
            this.$set(this.formData, 'in_journal_persons', res.data.inJournal.in_journal_persons || {})
          }
        })
        .catch((err) => {
          if (err.response.status === 404) {
            return this.$router.push({ name: 'sav404' })
          } else {
            this.$root.$emit('DATA_ERROR', err.response.data.message)
          }
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    goBack(){
      this.$router.push({ name: 'adminRequestsPreparedSent' })
    },
    confirmSave(){
      this.saveData()
    },
    saveData() {
      this.loading = true
      let url = this.formData.status == '801' ? `in-journals/requests/${this.getId ?? ''}` : `in-journals/requests/${this.getId}/update`
      let totalFileSize = 0
      let formData = new FormData()
      let emitError;
      let fileTypes = sessionStorage.getItem('file_types')


      // Add Files
      if (this.formData?.documents?.length > 0) {
        Object.keys(this.formData.documents).map((value, key) => {
          if (this.formData.documents[key].file != undefined) {
            totalFileSize += this.formData.documents[key].file.size
            let filename = this.formData.documents[key].file.name
            let extension = filename.substr(filename.lastIndexOf('.') + 1)

            if (fileTypes.includes(extension.toLowerCase())) {
              formData.append(
                `documents[${key}]`,
                this.formData.documents[key].file
              )
            } else {
              emitError = 'FILE_EXTENSION_NOT_ALLOWED'
            }
          }
        })
      }

      if (totalFileSize > sessionStorage.getItem('max_file_size')) {
        emitError = 'FILE_TOO_LARGE'
      }

      if (emitError === undefined) {
        // Add documents to delete
        if (this.formData?.documentsToDelete?.length > 0) {
          Object.keys(this.formData.documentsToDelete).map((value, key) => {
            formData.append(`documentsToDelete[${key}]`, this.formData.documentsToDelete[key])
          })
        }

        // Add rest data
        Object.keys(this.formData).map((key) => {
          if (key != 'documents' && key != 'data_provider' && key != 'documentsToDelete' && key != 'pro_principals' && key != 'procurators' && key != 'signatures' && key != 'in_journal_persons') {
            if(Array.isArray(this.formData[key])){
              let arr = this.convertObjectArray(this.formData[key], 'amn_id')
              this.appendArray(arr, key, formData)
            } else {
              formData.append(key, this.formData[key])
            }
          }
        })

        // formData.append(`signatures`, []);
        // if (this.formData?.signatures?.length > 0) {
        //     Object.keys(this.formData.signatures).map((value, key) => {
        //       formData.append(`signatures[${key}][amn_id]`, this.formData.signatures[key].amn_id || '')
        //       formData.append(`signatures[${key}][email_address]`, this.formData.signatures[key].email_address || '')
        //       formData.append(`signatures[${key}][phone_number_prepend]`, this.formData.signatures[key].phone_number_prepend || '')
        //       formData.append(`signatures[${key}][phone_number_prepend_iso]`, this.formData.signatures[key].phone_number_prepend_iso || '')
        //       formData.append(`signatures[${key}][phone_number]`, this.formData.signatures[key].phone_number || '')
        //       formData.append(`signatures[${key}][sms_enabled]`, this.formData.signatures[key].sms_enabled ? "1" : "0")
        //       formData.append(`signatures[${key}][email_enabled]`, this.formData.signatures[key].email_enabled ? "1" : "0")
        //     })
        // }
        if (this.formData?.in_journal_persons?.length > 0) {
          Object.keys(this.formData.in_journal_persons).map((value, key) => {
            formData.append(`inJournalPersons[${key}][amn_id]`, this.formData.in_journal_persons[key].amn_id || '')
            formData.append(`inJournalPersons[${key}][email_address]`, this.formData.in_journal_persons[key].email_address || '')
            formData.append(`inJournalPersons[${key}][phone_number_prepend]`, this.formData.in_journal_persons[key].phone_number_prepend || '')
            formData.append(`inJournalPersons[${key}][phone_number_prepend_iso]`, this.formData.in_journal_persons[key].phone_number_prepend_iso || '')
            formData.append(`inJournalPersons[${key}][phone_number]`, this.formData.in_journal_persons[key].phone_number || '')
            formData.append(`inJournalPersons[${key}][sms_enabled]`, this.formData.in_journal_persons[key].sms_enabled ? "1" : "0")
            formData.append(`inJournalPersons[${key}][email_enabled]`, this.formData.in_journal_persons[key].email_enabled ? "1" : "0")
          })
        }


        formData.append(`procurators`, []);
        if (this.formData?.procurators?.length > 0) {
            Object.keys(this.formData.procurators).map((value, key) => {
              formData.append(`procurators[${key}][amn_id]`, this.formData.procurators[key].amn_id || '')
              formData.append(`procurators[${key}][email_address]`, this.formData.procurators[key].email_address || '')
              formData.append(`procurators[${key}][phone_number_prepend]`, this.formData.procurators[key].phone_number_prepend || '')
              formData.append(`procurators[${key}][phone_number_prepend_iso]`, this.formData.procurators[key].phone_number_prepend_iso || '')
              formData.append(`procurators[${key}][phone_number]`, this.formData.procurators[key].phone_number || '')
              formData.append(`procurators[${key}][sms_enabled]`, this.formData.procurators[key].sms_enabled ? "1" : "0")
              formData.append(`procurators[${key}][email_enabled]`, this.formData.procurators[key].email_enabled ? "1" : "0")
            })
        }

        formData.append(`pro_principals`, []);
        if (this.formData?.pro_principals?.length > 0) {
          Object.keys(this.formData.pro_principals).map((value, key) => {
            formData.append(`pro_principals[${key}][amn_id]`, this.formData.pro_principals[key].amn_id  || '')
            formData.append(`pro_principals[${key}][email_address]`, this.formData.pro_principals[key].email_address || '')
            formData.append(`pro_principals[${key}][phone_number_prepend]`, this.formData.pro_principals[key].phone_number_prepend || '')
            formData.append(`pro_principals[${key}][phone_number_prepend_iso]`, this.formData.pro_principals[key].phone_number_prepend_iso || '')
            formData.append(`pro_principals[${key}][phone_number]`, this.formData.pro_principals[key].phone_number || '')
            formData.append(`pro_principals[${key}][sms_enabled]`, this.formData.pro_principals[key].sms_enabled ? "1" : "0")
            formData.append(`pro_principals[${key}][email_enabled]`, this.formData.pro_principals[key].email_enabled ? "1" : "0")
            formData.append(`pro_principals[${key}][jur_representers]`, [])
            Object.keys(this.formData.pro_principals[key].jur_representers).map((value, key2) => {
              formData.append(`pro_principals[${key}][jur_representers][${key2}][amn_id]`, this.formData.pro_principals[key].jur_representers[key2].amn_id) || ''
              formData.append(`pro_principals[${key}][jur_representers][${key2}][id]`, this.formData.pro_principals[key].jur_representers[key2].id || '')
              formData.append(`pro_principals[${key}][jur_representers][${key2}][email_address]`, this.formData.pro_principals[key].jur_representers[key2].email_address || '')
              formData.append(`pro_principals[${key}][jur_representers][${key2}][phone_number_prepend]`, this.formData.pro_principals[key].jur_representers[key2].phone_number_prepend || '')
              formData.append(`pro_principals[${key}][jur_representers][${key2}][phone_number_prepend_iso]`, this.formData.pro_principals[key].jur_representers[key2].phone_number_prepend_iso || '')
              formData.append(`pro_principals[${key}][jur_representers][${key2}][phone_number]`, this.formData.pro_principals[key].jur_representers[key2].phone_number || '')
              formData.append(`pro_principals[${key}][jur_representers][${key2}][sms_enabled]`, this.formData.pro_principals[key].jur_representers[key2].sms_enabled ? "1" : "0")
              formData.append(`pro_principals[${key}][jur_representers][${key2}][email_enabled]`, this.formData.pro_principals[key].jur_representers[key2].email_enabled ? "1" : "0")
            })
          })
        }

        // Atsisakantis asmuo
        // if (this.formData.status != '801' && this.formData.in_journal_type != '821') {
        //   formData.append('mandate_person_id', this.formData.in_journal_type == '822' ? this.formData.pro_principals[0].id : this.formData.procurators[0].id )
        // }
        if (this.formData.status != '801' && this.formData.in_journal_type != '421') {
          formData.append('mandate_person_id', this.formData.in_journal_type == '422' ? this.formData.pro_principals[0].id : this.formData.mandate_person_id )
        }
        this.$axios
          .post(url, formData)
          .then((res) => {
            // redirect
            this.$router.push({
              name: 'adminRequestsPreparedSent',
            })
            this.$root.$emit('DATA_OK_STEP')
          })
          .catch((err) => {
            this.$root.$emit('DATA_ERROR', err)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.$root.$emit(emitError)
        this.loading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
